import { Box, Flex, Heading, Text } from '@chakra-ui/react'

const AdminBlockCard = ({ children, title, shortDesc, primaryActions, secondaryActions, mobileActions }) => {
	const isInlineLayout = title === 'Industry List' || title === 'Country List' || title === 'Product Category List'
	return (
		// <Box
		// 	borderWidth={'1px'}
		// 	borderStyle={'solid'}
		// 	borderColor={'gray.300'}
		// 	rounded={'8'}
		// >
		// 	{isInlineLayout ? (
		// 		<Flex justify={'space-between'} pt={5} px={5}>
		// 			{(title || shortDesc) && (
		// 				<Box>
		// 					{title && (
		// 						<Heading as="h3"  fontWeight={'700'} fontSize={'20px'}>
		// 							{title}
		// 						</Heading>
		// 					)}
		// 					{shortDesc && (
		// 						<Text mt={1} color={'gray.600'}>
		// 							{shortDesc}
		// 						</Text>
		// 					)}
		// 				</Box>
		// 			)}

		// 			{actions && <Box>{actions}</Box>}
		// 		</Flex>
		// 		) : (
		// 			<Box pt={5} px={5}>
		// 				{(title || shortDesc) && (
		// 					<Box>
		// 						{title && (
		// 							<Heading as="h3" fontWeight="700" fontSize="20px">
		// 								{title}
		// 							</Heading>
		// 						)}
		// 						{shortDesc && (
		// 							<Text mt={1} color="gray.600">
		// 								{shortDesc}
		// 							</Text>
		// 						)}
		// 					</Box>
		// 				)}
		// 				{actions && <Box pt={5}>{actions}</Box>}
		// 			</Box>
		// 	)}
		// 	{mobileActions && <Box w={'100%'} p={5}>{mobileActions}</Box>}
		// 	<Box p={5}>{children}</Box>
		// </Box>

		<Box borderWidth="1px" borderColor="gray.300" rounded="8">
			<Box pt={5} px={5}>
				<Flex justify="space-between" align="center" flexWrap="wrap" gap={2}>
					<Box>
						{title && (
							<Heading as="h3" fontWeight="700" fontSize="20px">
								{title}
							</Heading>
						)}
						{shortDesc && (
							<Text mt={1} color="gray.600">
								{shortDesc}
							</Text>
						)}
					</Box>

					{/* Top-right: Search bar + Filter Icon */}
					{primaryActions && <Flex gap={2} align="center">{primaryActions}</Flex>}
				</Flex>

				{/* Secondary filter dropdowns below */}
				{secondaryActions && <Box pt={5}>{secondaryActions}</Box>}
			</Box>

			{mobileActions && <Box w="100%" p={5}>{mobileActions}</Box>}
			<Box p={5}>{children}</Box>
		</Box>
	)
}

export default AdminBlockCard
